export default __webpack_public_path__ + "static/media/google_icon.35bcce80.png";